import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Colors from "../../../constants/Colors";
import { LottieEmpty, Loader } from "../../../components/";
import FeelingEvolutionChart from "../../Recap/FeelingEvolutionChart";
import FirstFeelingChart from "../../Recap/FirstFeelingChart";
import BestAction from "../../Recap/BestAction";
import moment from "moment";

import { connect } from "react-redux";
import {
  selectTab,
  changeField,
  modifyManagerSurveyRequest,
  createManagerSurveyRequest,
  submitComment
} from "../../../services/manager/actions";
import { DialogContent } from "@material-ui/core";
import StepProgressBar from "./ProgressBar";
import HorizontalBarChart from "./HorizontalBarChart";
import Survey from "./Survey";

moment.locale("fr");

const colorRange = [
  "rgba(252,87,122,0.8)",
  "rgba(66,80,251,0.8)",
  "rgba(0,170,255,0.8)",
  "#FF9F40",
  "#FFC233"
];

const styles = theme => ({
  main: {
    height: "100%",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  },
  leftDiv: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    height: "100%"
    // height: "calc(100% - 40px)"
    // minHeight: 500
  },
  rightContainer: {
    height: "100%",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  },
  rightDiv: {
    overflow: "auto",
    height: "100%",
    flexDirection: "column",
    // display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: Colors.backGrey,
    flex: 4
    // height: "calc(100% - 40px)"
  },
  picture: {
    borderRadius: 8,
    objectFit: "contain",
    height: "auto",
    // height: "100%",
    width: "100%"
  },
  topLeft: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  bottomLeft: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    padding: 10
  },
  name: {
    fontWeight: 500,
    marginTop: 15
  },
  rank: {
    fontWeight: 500,
    color: Colors.pink
  },
  totalDone: {
    color: Colors.lightBlue,
    fontWeight: 500
  },
  profileStats: {
    marginTop: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "100%"
  },
  totalDoneDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  rangDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  legend: {
    // color: Colors.mediumGrey,
    color: Colors.blackGrey,
    opacity: 0.25
  },
  suggestions: {
    width: "90%",
    marginTop: 10,
    padding: 10,
    backgroundColor: Colors.blackGrey,
    borderRadius: 8,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  suggestionText: {
    color: "#fff"
  },
  italic: {
    fontStyle: "italic"
  },
  textField: {
    borderRadius: 30
  },
  suggestionDiv: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // justifyContent: "flex-end",
    flex: 1
  },
  title: {
    fontWeight: 500,
    marginBottom: 15,
    marginTop: 15
  },
  commentDiv: {},
  firstSection: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "flex-start",
    display: "flex"
  },
  paper: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    backgroundColor: "#fff",
    // marginTop: 30,
    height: 250,
    padding: 10,
    width: "90%",
    // padding: 5,
    flexDirection: "column",
    display: "flex",
    justifyContent: "center"
  },
  firstSectionLeft: {
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flex: 1
  },
  firstSectionRight: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  },
  secondSection: {
    width: "100%",
    marginTop: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  secondSectionLeft: {
    width: "100%",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  secondSectionRight: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  thirdSection: {
    width: "100%",
    marginBottom: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  repartition: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 5,
    width: "100%"
  },
  action: {
    width: "95%",
    height: 80,
    // flex: 1,
    padding: 15,
    marginBottom: 25,
    borderRadius: 20,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8"
  },
  actionsDiv: {
    width: "100%",
    marginBottom: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row"
  },
  progressSection: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    display: "flex"
  },
  doneActionsText: {
    color: Colors.text
  },
  questionsDiv: {
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "row",
    display: "flex"
  },
  questionsSection: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    display: "flex"
  },
  surveyButtonDiv: {
    width: "90%",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between"
  }
});

class UserProfile extends Component {
  state = {
    progress: 0,
    areMoreQuestionsVisible: false
  };

  componentDidMount() {}

  formatFeelingEvolution = feelingEvolution => {
    let data = [];
    feelingEvolution.forEach(el => {
      const month = moment(el.date).format("MMMM");
      const monthIndex = data.findIndex(dataEl => dataEl.mois === month);
      if (monthIndex > -1) {
        data[monthIndex].users++;
        data[monthIndex].Stress += el.stress;
        data[monthIndex].Confiance += el.confidence;
        data[monthIndex]["Aisance à l'oral"] += el.publicSpeaking;
        data[monthIndex]["Cohésion d'équipe"] += el.teamCohesion;
        data[monthIndex]["Productivité"] += el.productivity;
      } else {
        const newData = {
          mois: month,
          monthNumber: moment(el.date).month(),
          users: 1,
          Stress: el.stress || 0.1,
          Confiance: el.confidence || 0.1,
          "Aisance à l'oral": el.publicSpeaking || 0.1,
          "Cohésion d'équipe": el.teamCohesion || 0.1,
          Productivité: el.productivity || 0.1
        };
        data.push(newData);
      }
    });
    return data;
  };

  formatFirstFeeling = stats => {
    const result = [
      {
        title: "Stress",
        "Situation actuelle": 0
      },
      {
        title: "Confiance",
        "Situation actuelle": 0
      },
      {
        title: "Cohésion d'équipe",
        "Situation actuelle": 0
      },
      {
        title: "Aisance à l'oral",
        "Situation actuelle": 0
      }
    ];
    result[0]["Situation actuelle"] = stats.stress;
    result[1]["Situation actuelle"] = stats.confidence;
    result[2]["Situation actuelle"] = stats.teamCohesion;
    result[3]["Situation actuelle"] = stats.publicSpeaking;
    result.forEach(el => {
      el["Objectif"] = 9;
    });
    return result;
  };

  formatGoalsEvolution = (historical, goals) => {
    const result = [
      {
        title: "Leadership",
        "Situation actuelle": 0,
        Objectif: goals.leadership
      },
      {
        title: "Aisance à l'oral",
        "Situation actuelle": 0,
        Objectif: goals.publicSpeaking
      },
      {
        title: "Pro-activité",
        "Situation actuelle": 0,
        Objectif: goals.proactivity
      },
      {
        title: "Cohésion d'équipe",
        "Situation actuelle": 0,
        Objectif: goals.teamCohesion
      },
      {
        title: "Résilience",
        Objectif: goals.resilience,
        "Situation actuelle": 0
      }
    ];

    historical.forEach(el => {
      if (el.category === "leadership") {
        result[0]["Situation actuelle"]++;
      } else if (el.category === "publicSpeaking") {
        result[1]["Situation actuelle"]++;
      } else if (el.category === "proactivity") {
        result[2]["Situation actuelle"]++;
      } else if (el.category === "teamCohesion") {
        result[3]["Situation actuelle"]++;
      } else if (el.category === "resilience") {
        result[4]["Situation actuelle"]++;
      }
    });

    return result;
  };

  formatRepartition = historical => {
    const result = [
      {
        category: "Leadership",
        leadership: 0,
        value: 0,
        color: "rgba(252,87,122,0.8)"
      },
      {
        category: "Capacité à convaincre",
        publicSpeaking: 0,
        value: 0,
        color: "rgba(66,80,251,0.8)"
      },
      {
        category: "Pro-activité",
        proactivity: 0,
        value: 0,
        color: "rgba(0,170,255,0.8)"
      },
      {
        category: "Cohésion d'Équipe",
        teamCohesion: 0,
        value: 0,
        color: "#FF9F40"
      },
      {
        category: "Résilience",
        resilience: 0,
        value: 0,
        color: "#FFC233"
      }
    ];
    historical.forEach(el => {
      if (el.category === "leadership") {
        result[0].value++;
        result[0].leadership++;
      } else if (el.category === "publicSpeaking") {
        result[1].value++;
        result[1].publicSpeaking++;
      } else if (el.category === "proactivity") {
        result[2].value++;
        result[2].proactivity++;
      } else if (el.category === "teamCohesion") {
        result[3].value++;
        result[3].teamCohesion++;
      } else if (el.category === "resilience") {
        result[4].value++;
        result[4].resilience++;
      }
    });

    // for the display
    result.sort((a, b) => {
      return a.value - b.value;
    });

    return result;
  };

  handleChange = name => event => {
    let value = event.target.value;
    this.props.changeField({
      [name]: value
    });
  };

  submitComment = () => {
    this.props.submitComment({
      comment: this.props.userComment,
      userId: this.props.userSelected._id,
      managerId: this.props.userId
    });
  };

  onSaveManagerSurvey = () => {
    if (!this.props.managerSurvey._id) {
      this.props.createManagerSurveyRequest({
        userId: this.props.userSelected._id,
        managerId: this.props.userId,
        survey: this.props.managerSurvey
      });
    }
    this.props.modifyManagerSurveyRequest({
      surveyId: this.props.managerSurvey._id,
      survey: this.props.managerSurvey
    });
  };

  selectFavoriteActions = historical => {
    const newHistorical = Object.assign(historical, {});
    const favorite = newHistorical.sort((a, b) => {
      return b.rating - a.rating;
    });
    return favorite.slice(0, 2);
  };

  selectLastActions = historical => {
    const newHistorical = Object.assign(historical, {});
    const done = newHistorical.filter(el => el.rating);
    const last = newHistorical.sort((a, b) => {
      return moment(b.date) - moment(a.date);
    });
    const result = last.slice(0, 3).reverse();
    return result;
  };

  displayMoreQuestions = () => {
    this.setState({
      areMoreQuestionsVisible: !this.state.areMoreQuestionsVisible
    });
  };

  render() {
    const options = {
      strokeWidth: 2,
      from: { color: "#7ED321" },
      to: { color: "#FF0000" },
      step: (state, bar) => {
        bar.path.setAttribute("stroke", state.color);
      }
    };
    var containerStyle = {
      width: "200px",
      height: "200px"
    };
    const { classes, userSelected } = this.props;
    const {
      picture,
      firstName,
      lastName,
      totalDoneActions,
      jobFunction,
      rank,
      feelingEvolution,
      stats,
      historical,
      goals
    } = userSelected;

    return (
      <div className={classes.rightDiv}>
        <div className={classes.progressSection}>
          <Typography
            align="center"
            variant="h6"
            classes={{ root: classes.title }}
          >
            Progression
          </Typography>
          <StepProgressBar
            progress={
              (this.props.userSelected.totalDoneActions / goals.global) * 100
            }
          />
          <p className={classes.doneActionsText}>
            <span style={{ fontWeight: "bold" }}>{totalDoneActions} </span>
            actions réalisées sur un objectif de{" "}
            <span style={{ fontWeight: "bold" }}>{goals.global}</span>
          </p>
          {/* <Typography
            align="center"
            variant="h6"
            style={{ marginTop: 0, marginBottom: 0 }}
            classes={{ root: classes.title }}
          >
            Le feedback positif
          </Typography>
          <p className={classes.doneActionsText}>Bravo Anthony !</p> */}
        </div>
        <div className={classes.questionsSection}>
          <div className={classes.surveyButtonDiv}>
            <Button
              onClick={this.displayMoreQuestions}
              disabled={this.props.requesting}
              variant="outlined"
              color="primary"
            >
              {this.state.areMoreQuestionsVisible
                ? "Voir moins de questions"
                : "Voir davantage de questions"}
            </Button>
            {this.props.requesting ? (
              <Loader size={"45%"} />
            ) : (
              <Button
                onClick={this.onSaveManagerSurvey}
                disabled={this.props.requesting}
                variant="contained"
                color="primary"
              >
                Sauvegarder mes notes
              </Button>
            )}
          </div>
          <Survey
            areMoreQuestionsVisible={this.state.areMoreQuestionsVisible}
          />
        </div>
        <div className={classes.firstSection}>
          <div className={classes.firstSectionLeft}>
            <Typography
              align="center"
              variant="h6"
              classes={{ root: classes.title }}
            >
              Évolution des objectifs
            </Typography>
            <div className={classes.paper}>
              <FirstFeelingChart
                isSmall
                keys={["Situation actuelle", "Objectif"]}
                data={this.formatGoalsEvolution(historical, goals)}
              />
            </div>
          </div>
          <div className={classes.firstSectionRight}>
            <Typography
              align="center"
              variant="h6"
              classes={{ root: classes.title }}
            >
              Évolution
            </Typography>
            <div className={classes.paper}>
              {feelingEvolution.length < 1 ? (
                <div>
                  <LottieEmpty />
                </div>
              ) : (
                <FeelingEvolutionChart
                  data={this.formatFeelingEvolution(feelingEvolution)}
                />
              )}
            </div>
          </div>
        </div>
        <div className={classes.secondSection}>
          <div className={classes.secondSectionLeft}>
            <Typography
              align="center"
              variant="h6"
              classes={{ root: classes.title }}
            >
              Actions effectuées par catégorie
            </Typography>
            <div className={classes.repartition}>
              {/* <RepartionChart
                isSmall
                data={this.formatRepartition(historical)}
              /> */}
              <div className={classes.paper}>
                <HorizontalBarChart data={this.formatRepartition(historical)} />
              </div>
            </div>
          </div>
          <div className={classes.secondSectionRight}>
            <Typography
              align="center"
              variant="h6"
              classes={{ root: classes.title }}
            >
              Ses 3 dernières actions
            </Typography>
            <div className={classes.actionsDiv}>
              {this.selectLastActions(historical).map((el, i) => {
                return (
                  <BestAction
                    key={i}
                    date={el.date}
                    title={el.action.title}
                    category={el.category}
                    isManager
                    rating={el.rating}
                    donePercentage={el.donePercentage}
                    color={colorRange[i]}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className={classes.thirdSection}>
          <Typography
            align="center"
            variant="h6"
            classes={{ root: classes.title }}
          >
            Ses actions favorites
          </Typography>
          <div className={classes.actionsDiv}>
            {this.selectFavoriteActions(historical).map((el, i) => {
              return (
                <BestAction
                  date={el.date}
                  key={i}
                  title={el.action.title}
                  category={el.category}
                  rating={el.rating}
                  isManager
                  donePercentage={el.donePercentage}
                  color={colorRange[3 + i]}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    userSelected,
    userComment,
    managerSurvey,
    requesting
  } = state.manager;
  const { userId } = state.client;
  return {
    userId,
    userSelected,
    managerSurvey,
    userComment,
    requesting
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {
      changeField,
      submitComment,
      createManagerSurveyRequest,
      modifyManagerSurveyRequest
    }
  )(UserProfile)
);
